import React, { useEffect, useRef } from "react";
import './portfolio.scss';
import soilcast from './../../image/Soilcast.webp';
import spoat from './../../image/Spoat.webp';
import becharge from './../../image/Becharge.webp';
import brembo from './../../image/Brembo.webp'
import MXE from './../../image/MXE.webp';
import { Link } from "react-router-dom";

interface CardI {
    size: string;
    title: string;
    subtitle: string;
    link: string;
}

const Card: React.FC<CardI> = ({size, title, subtitle, link}) => {
    const parallaxRefs = useRef<(HTMLImageElement | null)[]>([]);

    const getColor = ()=>{
        if (title === "Soilcast") {
            return "#55DFA8"
        } else if (title === "SPOAT"){
            return "#0100F4"
        } else if (title === "BeCharge + Plenitude"){
            return "#2D2E4A"
        } else if (title === "Brembo"){
            return "#B32A31"
        } else if (title === "MXE"){
            return "#0c2340"
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            parallaxRefs.current.forEach(image => {
                if (image) {
                    const speed = 0.05;
                    const imageRect = image.getBoundingClientRect();
                    const offset = window.pageYOffset;
                    const imageTop = imageRect.top + window.pageYOffset;

                    const newYPosition = (offset - imageTop) * speed;
                    image.style.transform = `translate(-48%, ${newYPosition}px)`;
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className={"card " + size}>
                <div className="card-header">
                    <div className="card-title">
                        <h3 style={{ color: getColor() }}>{title}</h3>
                        <Link to={link}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12ZM13.172 18.047C12.731 18.488 12.019 18.488 11.583 18.047C11.147 17.606 11.142 16.894 11.583 16.458L14.911 13.13L6.375 13.125C5.752 13.125 5.25 12.623 5.25 12C5.25 11.377 5.752 10.875 6.375 10.875H14.911L11.583 7.547C11.142 7.106 11.142 6.394 11.583 5.958C12.023 5.522 12.736 5.517 13.172 5.958L18.422 11.203C18.862 11.644 18.862 12.356 18.422 12.792L13.172 18.047Z" fill={getColor()}/>
</svg>

                    </Link>
                        
                    </div>
                    <div className="card-subtitle">
                    <p>{subtitle}</p>
                    </div>
                    
                </div>
                <div className="card-body">
                    <Link to={link}>
                        {title === "Soilcast" && (
                            <img
                                className="parallax"
                                src={soilcast}
                                alt=""
                                ref={(el) => parallaxRefs.current[0] = el}
                            />
                        )}
                        {title === "SPOAT" && (
                            <img
                                className="parallax"
                                src={spoat}
                                alt=""
                                ref={(el) => parallaxRefs.current[1] = el}
                            />
                        )}
                        {title === "BeCharge + Plenitude" && (
                            <img
                                className="parallax"
                                src={becharge}
                                alt=""
                                ref={(el) => parallaxRefs.current[2] = el}
                            />
                        )}
                        {title === "Brembo" && (
                            <img
                                className="parallax"
                                src={brembo}
                                alt=""
                                ref={(el) => parallaxRefs.current[2] = el}
                            />
                        )}
                        {title === "MXE" && (
                            <img
                                className="parallax"
                                src={MXE}
                                alt=""
                                ref={(el) => parallaxRefs.current[2] = el}
                            />
                        )}
                    </Link>
                </div>
            </div>
        </>
    );
};

export default Card;